import { EntityKeyByReference, Note } from '@card-software/library';
import { IncomingReceiptLineBase } from '../receipt-line-base';
import { AuditTrail } from '@card-software/nexus-models';
import { Translation } from '../translation';
import { File } from '../order/shipment';
import { EntityKey } from './keys/entity-key';

export enum GoodsReceiptStatus {
  Pending = 0,
  Processing = 1,
  Completed = 2,
  Cancelled = 3,
}

export interface StatusHistoryEntry<TStatus> {
  date: Date;
  status: TStatus;
  user?: {
    username: string;
    displayName?: string;
  };
  comment?: string;
}

export interface GoodsReceiptLine extends IncomingReceiptLineBase {
  owner?: EntityKey;
}

export interface GoodsReceiptEntry extends AuditTrail {
  /** Descends from an Administrative purchase order (#5942); only role holders can see it, the API enforces. */
  isAdministrative?: boolean;
  id?: string;
  number?: string;
  initiator: EntityKeyByReference;
  status: GoodsReceiptStatus;
  locationCode: string;
  locationName?: Translation;
  receivedDate?: Date;
  lines: GoodsReceiptLine[];
  providerReference: string;
  deliveryNote?: string;
  invoiceNumber?: string;
  supportingDocuments?: File[];
  receiverUsername?: string;
  comments?: string;
  notes?: Note[];
  statusHistory?: StatusHistoryEntry<GoodsReceiptStatus>[];
  owner?: EntityKey;
}
